let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("23K0q")).then(() => parcelRequire('iOx72'));